import Http from '@/assets/ts/classes/Http'

const getProfile = async () => Http.get( '/member/profile' )

export default getProfile
